import React from 'react'
import { useEffect, useState, type FC } from 'react'
import WPAPI from 'wpapi'

declare global {
  interface Window {
    reactPress: IReactpress
  }
}

interface IProps {
  children: React.ReactNode
}

export const ReactPressContext = React.createContext<any>(undefined)

const ReactPress: FC<IProps> = ({ children }) => {
  const [reactPress, setReactPress] = useState<any>(undefined)

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') setReactPress({ user: { ID: 1 } })
    if (window.reactPress !== undefined) {
      setReactPress(window.reactPress)
    }
  }, [])

  const options =
    process.env.NODE_ENV === 'development'
      ? {
          endpoint: window.location.protocol + '//' + window.location.hostname + '/wordpress/wp-json',
          username: process.env.REACT_APP_WP_API_USERNAME,
          password: process.env.REACT_APP_WP_API_PASSWORD,
        }
      : { endpoint: reactPress?.api?.rest_url ?? '', nonce: reactPress?.api?.nonce ?? '' }

  const wpapi = new WPAPI(options)

  if (reactPress === undefined) return <div className='animate-skeleton w-full h-full' />
  return <ReactPressContext.Provider value={{ wpapi, reactPress }}>{children}</ReactPressContext.Provider>
}

export default ReactPress
